export const initialStores = [
  {
    resources: {
      storeDetails: '',
      customFittingLink: '',
      customFitting: '',
    },
    cartId: '',
    ID: '',
    name: '',
    address1: '',
    address2: '',
    city: '',
    postalCode: '',
    stateCode: '',
    countryCode: '',
    phone: '',
    email: '',
    latitude: 0,
    longitude: 0,
    redeyeUrl: '',
    selectUrl: '',
    stockMessage: '',
    googlePlaceID: '',
    redeye: '',
    listAddress: '',
  },
];

export default initialStores;
